const savedViews = 'savedViews';

export const FETCH_VIEWS_REQUEST = `${savedViews}/FETCH_VIEWS_REQUEST`;
export const FETCH_VIEWS_RESPONSE = `${savedViews}/FETCH_VIEWS_RESPONSE`;
export const FETCH_VIEWS_ERROR = `${savedViews}/FETCH_VIEWS_ERROR`;

export const BULK_DELETE_VIEWS_REQUEST = `${savedViews}/BULK_DELETE_VIEWS_REQUEST`;

export const MAKE_A_COPY_REQUEST = `${savedViews}/MAKE_A_COPY_REQUEST`;
